import { enumToTitleCase } from '../../utilities/stringUtilities'
import { getOrdinalSuffix } from '../../utilities/randomUtilities'

export const getRecurringServiceOn = (recurringService) => {
  if (!recurringService?.serviceInterval) return 'None'

  const {
    serviceInterval,
    serviceDay,
    serviceDate,
    serviceDailyFrequency
  } = recurringService

  switch (serviceInterval) {
    case 'WEEKLY': {
      const days = serviceDay.map(e => enumToTitleCase(e)).join(', ')
      return serviceDay ? `Every ${days}` : 'None'
    }

    case 'MONTHLY': {
      if (!Array.isArray(serviceDate) || serviceDate.length === 0) {
        return 'None'
      }
      const formattedDates = serviceDate.map(date =>
        `${Number(date)}${getOrdinalSuffix(Number(date))}`
      )
      return `${formattedDates.join(', ')} of every month`
    }

    case 'EVERY_X_DAYS': {
      const frequency = Number(serviceDailyFrequency)
      if (frequency === 1) return 'Daily'
      return frequency
        ? `Every ${frequency} days`
        : 'None'
    }

    default:
      return 'None'
  }
}
